import Vue, { VNode, VNodeChildren } from 'vue'
import type { WithRefs } from 'vue-typed-refs'
import { WeveDialog } from '@weve/ui'
import type { DialogProps } from '@weve/ui/dist/components/Dialog/Dialog.types'

import mountVueToBody from './mountVueToBody'
import { VueComponentListeners } from '@/types'

/**
 * Wraps content into a dialog.
 */
export default function dialogify(
  parent: Vue,
  content: VNodeChildren,
  props: DialogProps,
  listeners: VueComponentListeners = {}
) {
  const Dialog = (
    Vue as WithRefs<{ dialog: InstanceType<typeof WeveDialog> }>
  ).extend({
    name: 'DialogifyWrapper',
    computed: {
      listeners(): VueComponentListeners {
        return {
          ...listeners,
          hide: Array.isArray(listeners.hide)
            ? [this.onHide, ...listeners.hide]
            : listeners.hide !== undefined
            ? [this.onHide, listeners.hide]
            : this.onHide,
        }
      },
    },
    methods: {
      onHide() {
        this.$destroy()
        this.$el.remove()
      },
      hide() {
        this.$refs.dialog.hide()
      },
    },
    render(h): VNode {
      return h(
        WeveDialog,
        { ref: 'dialog', props, on: this.listeners },
        content
      )
    },
    parent,
  })
  const instance = new Dialog()
  const destroyer = mountVueToBody(instance)
  const hide = () => instance.hide()
  return { instance, destroyer, hide }
}
